import { useSelector } from "react-redux";
import {
  LanguageData,
  selectLocalizedLanguages,
  selectTrainingLocalizationState,
  UpdateSetOfKeys,
} from "../../app/slices/TrainingLocalizationSlice";
import Interaction from "../../models/interactions/Interaction";
import { getKeysFromInteraction } from "../../helpers/KeysHelper";
import { selectReferenceLanguage } from "../../app/slices/TrainingSlice";
import { TranslationService } from "../../services/TranslationService";
import { selectToken } from "../../app/slices/AuthenticationSlice";
import { useDispatch } from "react-redux";

export default function useInteractionsTranslation() {
  const locState = useSelector(selectTrainingLocalizationState);
  const currentLanguages = useSelector(selectLocalizedLanguages);
  const referenceLanguage = useSelector(selectReferenceLanguage);
  const token = useSelector(selectToken);
  const dispatch = useDispatch();

  const translateAll = async (
    interaction: Interaction,
    missingOnly: boolean = false
  ) => {
    // 1. get all keys
    var keys = getKeysFromInteraction(interaction, "key_");

    // 2. get ref lang, get texts from ref lang
    var texts = keys.map(
      (key) => locState.localizedEntries[key][referenceLanguage].value
    );

    // 3. translate
    var langsToTranslate = currentLanguages.filter(
      (lang) => lang.shortcode !== referenceLanguage
    );
    langsToTranslate.forEach(async (lang) => {
      await translateAllForLanguage(lang, keys, texts, missingOnly);
    });
  };

  const translateAllForLanguage = async (
    lang: LanguageData,
    keys: string[],
    texts: string[],
    missingOnly: boolean = false
  ) => {
    const from = referenceLanguage;
    const to = lang.shortcode;

    if (missingOnly) {
      keys = keys.filter(
        (key) =>
          !locState.localizedEntries[key][lang.shortcode].value ||
          locState.localizedEntries[key][lang.shortcode].value === "" ||
          locState.localizedEntries[key][lang.shortcode].value === " "
      );

      texts = keys.map(
        (key) => locState.localizedEntries[key][referenceLanguage].value
      );
    }

    var results = await TranslationService.TranslateTexts(
      token!,
      texts,
      from,
      to
    );

    dispatch(
      UpdateSetOfKeys({ lang: lang.shortcode, keys: keys, values: results })
    );
  };

  return { translateAll };
}
